import $ from 'jquery';

const SmoothScroll = function () {
  const scrollTo = (offset, callback) => {
    $('html, body').animate({
      scrollTop: offset
    }, 500, callback || null);
  };

  return {
    scrollTo
  };
}();

export default SmoothScroll;


// WEBPACK FOOTER //
// ./src/js/utils/smoothScroll.js